var _path, _circle, _path2, _circle2, _path3, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC0C7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.262 1.484H18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.565,
    cy: 1.565,
    r: 1.565,
    fill: "#BEC0C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC0C7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.262 8.922H18"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.565,
    cy: 8.999,
    r: 1.565,
    fill: "#BEC0C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC0C7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.262 16.355H18"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.565,
    cy: 16.436,
    r: 1.565,
    fill: "#BEC0C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.fc7cdfeb76e71f290cc33f4d00ce03dd.svg";
export { ForwardRef as ReactComponent };